import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Language from "./Language";

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    language: Language
});

export default reducers;
